<app-menu-common url="logistic"></app-menu-common>

<!-- Carte affichée : le header (date, créneau, boutons) passe PAR-DESSUS la carte (.over-map),
     qui occupe ainsi presque tout l'écran. ?map=full = fenêtre dissociée (carte seule, board masqué). -->
<div class="board-top" [class.with-map]="showMap()">
	<div class="delruns-header" [class.over-map]="showMap()">
		<app-select-date label="" [date]="date" (dateChange)="onDateChange($event)"></app-select-date>

		<mat-button-toggle-group class="slot-toggle" [value]="slotFilter()" hideSingleSelectionIndicator aria-label="Filtre créneau">
			<mat-button-toggle [value]="1" (click)="onSlotFilterClick(1)">Matin ({{ countMorning }})</mat-button-toggle>
			<mat-button-toggle [value]="2" (click)="onSlotFilterClick(2)">Après-midi ({{ countAfternoon }})</mat-button-toggle>
		</mat-button-toggle-group>

		@if (!fullMap) {
			<!-- disabledInteractive : grisé, le bouton garde son infobulle, qui dit quelles tournées valider d'abord. -->
			<button mat-icon-button class="print-all" [disabled]="!runsToPrint.length || runsNotSaved.length > 0" disabledInteractive
				[title]="printAllTitle" (click)="printAllRuns()">
				<mat-icon>print</mat-icon>
			</button>
		}

		<span class="spacer"></span>

		@if (fullMap && synced()) {
			<!-- La carte reflète le board en direct. Absent = instantané de la base : le board est fermé,
			     ou il regarde une autre journée / un autre créneau que les contrôles ci-contre. -->
			<span class="sync-chip" title="Cette carte suit le board en direct, drag & drop compris">
				<mat-icon inline>sync</mat-icon>&nbsp;Synchronisée
			</span>
		}

		@if (!fullMap) {
			@if (dirtyCount > 1) {
				<button mat-stroked-button color="primary" (click)="saveAll()">
					<mat-icon>done_all</mat-icon>&nbsp;Tout valider ({{ dirtyCount }})
				</button>
			}
			<button mat-stroked-button (click)="toggleMap()">
				<mat-icon>map</mat-icon>&nbsp;{{ showMap() ? 'Masquer la carte' : 'Carte' }}
			</button>
			<!-- Toujours proposé, carte du board affichée ou non : on dissocie la carte JUSTEMENT pour ne
			     pas l'afficher dans le board (second écran) — l'exiger d'abord était un clic pour rien. -->
			<button mat-stroked-button (click)="openMapWindow()"
				title="Ouvrir la carte dans une fenêtre séparée (second écran) — elle suit le board en direct, drag & drop compris">
				<mat-icon>open_in_new</mat-icon>&nbsp;Carte (fenêtre)
			</button>
			<button mat-flat-button color="primary" (click)="createRun()">
				<mat-icon>add</mat-icon>&nbsp;Nouvelle tournée
			</button>
		}
	</div>

	@if (showMap()) {
		<app-delruns-map [points]="mapPoints" [height]="mapHeight"></app-delruns-map>
	}
</div>

<!-- Fenêtre carte dissociée : la carte occupe déjà tout l'écran, un spinner en dessous la ferait défiler -->
@if (fullMap && loading()) {
	<div class="loading-hint">Chargement…</div>
}

<!-- Board vidé le temps d'aller chercher la journée : les colonnes ne reviennent qu'avec ses données
     (un board vide afficherait « Aucune livraison à planifier », ce qui serait faux). -->
@if (!fullMap && loading()) {
	<div class="board-loading">
		<mat-progress-spinner mode="indeterminate" diameter="80" strokeWidth="8" color="primary"></mat-progress-spinner>
	</div>
}

@if (!fullMap && !loading()) {
	<div class="board" cdkDropListGroup>
		<div class="unassigned-column">
			<!-- Le tri se loge dans l'espace libre de l'entête : ni hauteur ni vignette perdues -->
			<div class="column-title">À planifier <span class="count">{{ visibleUnassigned.length }}</span>
				<span class="spacer"></span>
				<button type="button" class="sort-toggle" [class.on]="sortByRef()" (click)="toggleSortByRef()"
					[title]="sortByRef() ? 'Trié par repère (A, B, C…) — cliquer pour revenir au tri par créneau' : 'Trié par créneau (ASAP, matin, après-midi) — cliquer pour trier par repère de carte'">
					<mat-icon inline>sort_by_alpha</mat-icon>
				</button>
			</div>
			<div class="unassigned-list" cdkDropList [cdkDropListData]="visibleUnassigned" (cdkDropListDropped)="onDrop($event)">
				@for (d of visibleUnassigned; track d.id) {
					<div class="drag-item" cdkDrag [cdkDragData]="d" [cdkDragDisabled]="!!d.realdatdel">
						<app-delivery-card [delivery]="d" [slots]="slots" [ops]="ops" [ref]="refOf(d)" [highlight]="d.id === highlightBl()"></app-delivery-card>
					</div>
				}
				@if (!visibleUnassigned.length) {
					<div class="empty-hint">Aucune livraison à planifier</div>
				}
			</div>
		</div>

		@for (vm of visibleRuns; track vm.run) {
			<app-delrun
				[run]="vm.run"
				[deliveries]="vm.deliveries"
				[vehicles]="vehicles"
				[users]="users"
				[deliverers]="deliverers"
				[slots]="slots"
				[ops]="ops"
				[dirty]="vm.dirty"
				[saving]="vm.saving ?? false"
				[color]="colorOf(vm)"
				[stores]="stores"
				[depotStore]="vm.depotStore ?? null"
				[startSlot]="vm.startSlot ?? null"
				[route]="vm.route ?? null"
				[schedule]="vm.schedule ?? null"
				[highlightBl]="highlightBl()"
				(depotChange)="onDepotChange(vm, $event)"
				(startSlotChange)="onStartSlotChange(vm, $event)"
				(slotChange)="onSlotChange(vm, $event)"
				(durationChange)="onDurationsChange(vm)"
				(arrivalChange)="onArrivalChange(vm, $event.index, $event.value)"
				(arrivalClear)="onArrivalClear(vm, $event)"
				(dropped)="onDrop($event)"
				(changed)="markDirty(vm)"
				(save)="saveRun(vm)"
				(remove)="confirmDeleteRun(vm)"
				(printBl)="printRunBl(vm)">
			</app-delrun>
		}

		@if (!visibleRuns.length) {
			<div class="no-run-hint">
				<mat-icon>local_shipping</mat-icon>
				<div>Aucune tournée pour cette journée.<br />Créez-en une avec « Nouvelle tournée » puis glissez-y des livraisons.</div>
			</div>
		}
	</div>
}
